import ModalSentErrorWithInfo from 'modules/FirmwareAndApp/Apk/Apk/components/ModalWindows/ModalSentErrorWithInfo/ModalSentErrorWithInfo';
import React, { useCallback, useContext } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { ApkContext, IApkContext } from 'modules/FirmwareAndApp/Apk/Apk/apkState/apkContext';

export const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		showErrorModalWithInfo,
		deleteSelectedItem,
		errorResponseData,
		typeOfModalWindow,
	} = useContext<IApkContext>(ApkContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	const handleCloseModalWithInfo = useCallback(() => showErrorModalWithInfo(null), [showErrorModalWithInfo]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !!errorResponseData}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteTabletApp"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteTabletAppSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingTabletApp"
			/>
			<ModalSentErrorWithInfo
				onConsentEvent={handleCloseModalWithInfo}
				isVisible={!!errorResponseData}
				errorResponseData={errorResponseData}
			/>
		</ModalWrapper>
	);
};
